






































import { defineComponent, PropType, ref } from '~/utils/nuxt3-migration'
import { AuditRequest } from '~/models/audit/request'
import { useSnackbar } from '~/compositions/snackbar'
import { useI18n } from '~/compositions/i18n'
import AuditRequestService from '~/services/audits/AuditRequestService'
import { useDep } from '~/compositions/dependency-container'
import CancelAuditButton from '~/components/shared/audits/request/timeline/CancelAuditButton.vue'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineComponent({
  components: { CancelAuditButton },
  props: {
    auditRequest: {
      type: Object as PropType<AuditRequest>,
      required: true
    }
  },
  setup(props, { emit }) {
    const isLoading = ref(false)
    const acceptDisclaimer = ref(false)

    const snackbar = useSnackbar()
    const { t } = useI18n()
    const auditRequestService = useDep(AuditRequestService)

    async function acceptAuditRequest() {
      isLoading.value = true

      const { auditRequest } = await auditRequestService.acceptAuditRequest(
        props.auditRequest.id
      )

      snackbar.success(t('acceptance_audit_successful'))
      emit('update-audit-request', auditRequest)
      isLoading.value = false
    }

    return { acceptAuditRequest, isLoading, acceptDisclaimer }
  },
  i18n: defineComponentTranslations({
    cancel_audit_request: {
      en: 'Cancel audit request',
      el: 'Ακύρωση αιτήματος ελέγχου'
    }
  })
})
